// extracted by mini-css-extract-plugin
module.exports = {"eliteFooterWrapper":"DRn0j"};